export default "__VITE_ASSET__DvLSmuEp__"